import React, { useEffect, useState } from "react";
import { Select, Input, Modal, Space, Button, message } from "antd";
import { DeleteOutlined } from '@ant-design/icons';
import { baseAxiosNoInfo } from "../../../tool/axios";
import _ from "lodash";
import '../css/CustomerMenuReplace.css';
const { Option } = Select

type DishesRepalceProps = {
    visibleModule: boolean,
    updateStepData:any,
    updateDishesInfo: {
        mealRowIndex: any,
        currentStep: any,
        currentDay: any,
        meal_times: any,
        meal_times_text: any,
        menu_item_list: any
    },
    foodTypeList: any,
    onModuleCancel: any,
    onGetUpdateFoodData: any
}

export default function DishesReplacement(props: DishesRepalceProps) {
    const { currentStep, currentDay, meal_times, meal_times_text, menu_item_list, mealRowIndex } = props.updateDishesInfo
    const [visible, setVisible] = useState<boolean>(props.visibleModule)
    // 设置选择菜品的类型
    const [foodType, setFoodType] = useState<any>()
    // 设置选择的菜品
    const [foodList, setFoodList] = useState<any[]>([])
    const [food, setFood] = useState<{
        menu_item_id: string,
        menu_item_name: string,
        is_high_price: number
    }>()

    // 添加菜品列表
    const [addFoodList, setAddFoodList] = useState<any[]>([])

    
    useEffect(() => {
        setVisible(props.visibleModule)
    },[props.visibleModule])

    useEffect(() => {
        let stepData  = _.cloneDeep(props.updateStepData)
        // 回显更换菜品列表
        if(currentStep != undefined && currentDay !=undefined && meal_times !=undefined) {
            let menuItemListObj =  stepData[currentStep]['detail'][currentDay]['food_row'][meal_times-1]['menu_item_list'][mealRowIndex]
            setAddFoodList([...menuItemListObj.menu_item_replace_list])
        }
    }, [props.updateStepData, props.updateDishesInfo])
    
    return (
        <Modal
            title="更换菜品" 
            width={600} 
            visible={visible}
            onOk={() => {
                let isAllEmpty = addFoodList.every((el:any) => !el.menu_item_count)
                if(isAllEmpty) {
                    return message.error('至少一个菜品数量不能为0，否则不能提交。')
                }
                const { updateStepData } = props
                // 外部的阶段数据
                let stepData  = _.cloneDeep(updateStepData)
                let menuItemListObj =  stepData[currentStep]['detail'][currentDay]['food_row'][meal_times-1]['menu_item_list'][mealRowIndex]
                menuItemListObj.menu_item_replace_list = [
                    ...addFoodList
                ]
                // 处理添加好的数据
                props.onGetUpdateFoodData(stepData)
                props.onModuleCancel(false)
                setVisible(false)
                setFood(undefined)
                setFoodList([])
                setAddFoodList([])
                setFoodType(undefined)
            }}
            onCancel={() => { 
                props.onModuleCancel(false)
                setVisible(false)
                setFood(undefined)
                setFoodList([])
                setAddFoodList([])
                setFoodType(undefined)
            }} 
        >
            <div>您所选择的是</div>
            <div className="dishesModule-step-text">
                <span>第{currentStep+1}阶段</span>
                <span>第{currentDay+1}天</span>
                <span>{meal_times_text}</span>
            </div>
            <div><span>{menu_item_list.menu_item_name}</span></div>
            <div>
                <div>选择可更换的菜品</div>
                <div>
                    <Select 
                        allowClear placeholder="选择菜品分类" 
                        style={{ maxWidth: 280, marginRight: 14 }}
                        value={foodType}
                        onChange={(v: string) => {
                            setFoodType(v)
                            // 查询该分类下的菜品
                            baseAxiosNoInfo('/cooking_center/global/menu_item_list_by_type_id', {
                                params: {
                                    menu_type_id: v
                                }
                            }).then((res: any) => {
                                setFood(undefined)
                                setFoodList([])
                                if(res && res.length) {
                                    res.forEach((ele: any) => {
                                        ele.menu_item_count = 0
                                    })
                                    setFoodList(res)
                                }
                            })
                        }}
                        onClear={() => setFoodList([])}>
                        {props.foodTypeList.map((el: any) =>
                            <Option key={el.menu_type_id} 
                                value={el.menu_type_id}>
                                {el.menu_type_name}
                            </Option>)}
                    </Select>
                    <Select 
                        style={{ maxWidth: 280 }} 
                        allowClear 
                        placeholder="选择菜品"
                        value={food?.menu_item_id}
                        onChange={(v: any) => {
                            setFood(foodList.find((el: any) => el.menu_item_id === v))
                        }}
                    >
                        {
                            foodList.map((el:any) => 
                                <Option key={el.menu_item_id} value={el.menu_item_id}>
                                    {el.menu_item_name}
                                </Option>)
                        }
                    </Select>
                    <Button 
                        type="primary" 
                        style={{ marginLeft: 10 }} 
                        onClick={() => {
                            if(!food) {
                                return message.error('必须先选择菜品分类和菜品')
                            }
                            if(addFoodList && addFoodList.length > 0) {
                                let bool = addFoodList.some(el => el.menu_item_id === food?.menu_item_id)
                                if(bool) {
                                    return message.error('菜品已存在该餐次当中')
                                }
                            }
                            
                            setAddFoodList([...addFoodList, food])
                        }}
                    >添加</Button>
                </div>
                <div className="dishesBox">
                   <div className="dishesItem">
                        {
                            addFoodList.length > 0 ? addFoodList.map((el:any, idx) => {
                                return (
                                    <div className="itemBox" key={el.menu_item_id}>
                                        <span>{el.menu_item_name}</span>
                                        <Space style={{ margin: '8px', marginBottom: 10 }}>
                                            <Input style={{ width: '50px', height: '25px' }} 
                                                onChange={(e:any) => {
                                                    let num = Number(e.target.value)
                                                    if(isNaN(num)){
                                                        message.error('必须填写数字')
                                                    } else {
                                                        let foodList = _.cloneDeep(addFoodList)
                                                        foodList[idx]['menu_item_count'] = num
                                                        setAddFoodList(foodList)
                                                    }
                                                }} 
                                                value={el.menu_item_count}
                                            />
                                        </Space>
                                        <DeleteOutlined 
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                let foodList = _.cloneDeep(addFoodList)
                                                foodList.splice(idx, 1)
                                                setAddFoodList(foodList)
                                            }}
                                        />
                                    </div>
                                )
                            }) :''
                        }
                   </div>
                </div>
            </div>
        </Modal>
    )
}
